import { render } from "./modal.vue?vue&type=template&id=cf9f97d0&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=cf9f97d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf9f97d0"

export default script